import { apiService } from '../APIService';
import { User } from '../../store/User';
import { PaymentFrequency } from '../../utils/constants';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export interface PaymentFrequencyException {
  id: string;
  supplierId: string;
  supplierName: string;
  supplierSfid: string;
  paymentFrequency: PaymentFrequency;
  createdBy: User | null;
  createdAt: string;
  updatedAt: string;
}

export interface NewPaymentFrequencyException {
  supplierId: string;
  paymentFrequency: PaymentFrequency;
}

export const paymentFrequencyExceptionList = () => {
  return apiService.callExternalApi<PaymentFrequencyException[]>({
    url: `${API_SERVER_URL}/supplier-payment-frequency-exceptions`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const deletePaymentFrequencyException = (id: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/supplier-payment-frequency-exceptions/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const createPaymentFrequencyException = (record: NewPaymentFrequencyException) => {
  return apiService.callExternalApi<PaymentFrequencyException>({
    url: `${API_SERVER_URL}/supplier-payment-frequency-exceptions`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: record
  });
};
